import { render, staticRenderFns } from "./ActiveStore.vue?vue&type=template&id=67dc2cc3&scoped=true&lang=pug"
import script from "./ActiveStore.vue?vue&type=script&lang=js"
export * from "./ActiveStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc2cc3",
  null
  
)

export default component.exports